import Guard from '../../services/Middleware'

export default [
  {
    path: '/Agenda',
    name:'Agenda',
    component: () => import('@/views/agenda/index.vue'),
    beforeEnter: Guard.auth
  },
]